import { render, staticRenderFns } from "./TermsAndPrivacyText.vue?vue&type=template&id=325d58dc&scoped=true&"
import script from "./TermsAndPrivacyText.vue?vue&type=script&lang=js&"
export * from "./TermsAndPrivacyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d58dc",
  null
  
)

export default component.exports